import { render, staticRenderFns } from "./ValidacaoPrescricao.vue?vue&type=template&id=5e01205e&"
import script from "./ValidacaoPrescricao.vue?vue&type=script&lang=js&"
export * from "./ValidacaoPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports